/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

const apiUrl = "/api/wes/ProtectedCmsPage/validatePassword";

export interface ValidateResourcesPagePasswordParameter extends ApiParameter {
    password: string;
}

export const validateResourcesPagePassword = (parameter: ValidateResourcesPagePasswordParameter) => {
    return post(`${apiUrl}`, parameter.password);
};
